import { Injectable } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ConfigService } from 'app/app-config.service';
import { NgcCookieConsentService } from 'ngx-cookieconsent';

@Injectable({
    providedIn: 'root',
})
export class CookieConsentService {
    /**
     * Constructor
     *
     * @param configService
     * @param _translateService
     * @param _cookieConsentService
     */
    constructor(
        private configService: ConfigService,
        private _translateService: CustomTranslateService,
        private _cookieConsentService: NgcCookieConsentService,
    ) {
        this.updateCookiePopup();
        this._translateService.onLangChange.subscribe(() => this.updateCookiePopup());
    }

    updateCookiePopup() {
        this._translateService
            .get(['cookie.message', 'cookie.dismiss', 'cookie.link', 'cookie.policy'])
            .subscribe((data) => {
                this._cookieConsentService.getConfig().content =
                    {
                        ...this._cookieConsentService.getConfig().content,
                        message: data['cookie.message'],
                        dismiss: data['cookie.dismiss'],
                        link: data['cookie.link'],
                        href: `/assets/docs/conditions_${this._translateService.currentLang ?? 'en'}.pdf`,
                        policy: data['cookie.policy'],
                    } || {};

                this._cookieConsentService.getConfig().cookie = {
                    ...this._cookieConsentService.getConfig().cookie,
                    domain: this.configService.getConfig.domain ?? 'localhost',
                };

                this._cookieConsentService.getConfig().palette = {
                    ...this._cookieConsentService.getConfig().palette,
                    popup: {
                        ...this._cookieConsentService.getConfig().palette?.popup,
                        background: this.configService.getClient.mainColor,
                    },
                    button: {
                        ...this._cookieConsentService.getConfig().palette?.button,
                        text: this.configService.getClient.mainColor,
                    },
                };

                this._cookieConsentService.destroy();
                this._cookieConsentService.init(this._cookieConsentService.getConfig());
            });
    }
}
